import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { StyleSheet, css } from 'aphrodite';
import { Link } from 'react-router-dom';
import { Theme } from '../../config/theme';

let styles;

export default class EditProfileSummary extends Component {
  render() {
    const profileLink = `/${this.props.dog ? 'pooch' : 'profile'}/${this.props.id}`;

    return (
      <div className={css(styles.container)}>
        <div className={css(styles.content_container)}>
          <div className={css(styles.image_container)}>
            <div className={css(styles.image_wrapper)}>
              <Link to={profileLink}>
                <img className={css(styles.image)} src={this.props.image_url} alt="Profile" />
              </Link>
            </div>
          </div>
          <div className={css(styles.information_container)}>
            <div className={css(styles.title)}>
              {this.props.name}
            </div>
            {
              this.props.breed ? (
                <div className={css(styles.subtitle)}>
                  {this.props.breed}
                </div>
              ) : false
            }
          </div>
          <div className={css(styles.actions)}>
            <Link
              to={profileLink}
              className={css(styles.action_link, styles.left_action)}>
                View
            </Link>
            <Link
              to={`${profileLink}/edit`}
              className={css(styles.action_link, styles.right_action)}>
                Edit
            </Link>
          </div>
        </div>
      </div>
    );
  }
}

EditProfileSummary.defaultProps = {
  image_url: null,
  name: null,
  breed: null,
  dog: true,
};

EditProfileSummary.propTypes = {
  id: PropTypes.number.isRequired,
  image_url: PropTypes.string,
  name: PropTypes.string,
  breed: PropTypes.string,
  dog: PropTypes.bool,
};

styles = StyleSheet.create({
  container: {
    position: 'relative',
    display: 'flex',
    width: '750',
    height: 100,
    margin: '20px auto',
    backgroundColor: Theme.white,
    boxShadow: '0 1px 4px rgba(0, 0, 0, 0.1)',

    [Theme.mobile_query]: {
      width: '100%',
      height: 'auto',
      padding: '15px 0',
    },
  },
  content_container: {
    position: 'relative',
    display: 'flex',
    flexWrap: 'wrap',
    flexDirection: 'row',
    alignItems: 'center',
    width: '100%',
    height: '100%',
    boxSizing: 'border-box',
    paddingLeft: 20,
    paddingRight: 20,
  },
  image_container: {
    display: 'flex',
    alignItems: 'center',
    flex: 1,
    flexShrink: 0,
  },
  image_wrapper: {
    zIndex: 1,
    width: 60,
    height: 60,
    borderRadius: 30,
    borderWidth: 2,
    borderColor: '#fff',
    borderStyle: 'solid',
    backgroundColor: '#fff',
    boxShadow: '0 1px 4px rgba(0, 0, 0, 0.3), 0 0 40px rgba(0, 0, 0, 0.1) inset',
    overflow: 'hidden',
  },
  image: {
    zIndex: -1,
    cursor: 'pointer',
    display: 'block',
    height: '100%',
    width: '100%',
  },
  information_container: {
    flex: 6,
    display: 'flex',
    flexDirection: 'column',

    [Theme.mobile_query]: {
      paddingLeft: 20,
    },
  },
  title: {
    fontFamily: Theme.font_family_heading,
    fontSize: 20,
    color: Theme.black,
    fontWeight: 'bold',
  },
  subtitle: {
    marginTop: 10,
    fontFamily: Theme.font_family_primary,
    fontSize: 15,
    color: Theme.black,
  },
  actions: {
    flex: 1,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',

    [Theme.mobile_query]: {
      flex: 'initial',
      width: '100%',
      justifyContent: 'center',
      marginTop: 15,
    },
  },
  action_link: {
    display: 'flex',
    alignItems: 'center',
    fontFamily: Theme.font_family_secondary,
    fontSize: 15,
    fontWeight: 'bold',
    height: 40,
    width: 50,
    textTransform: 'uppercase',
  },
  left_action: {
    color: Theme.black,
    justifyContent: 'flex-start',
    borderRight: `1px solid ${Theme.horizontal_rule_color}`,
    boxSizing: 'content-box',
    paddingRight: 5,
  },
  right_action: {
    color: Theme.primary,
    justifyContent: 'flex-end',
  },
});



// WEBPACK FOOTER //
// ./src/components/EditProfileSummary/index.js